import { Link } from 'react-router-dom';

export default function ToolsHero() {
  return (
    <section className="relative min-h-[60vh] flex items-center overflow-hidden bg-[#F8F5F0]">
      {/* Right image */}
      <div className="absolute top-0 right-0 w-[48%] h-full hidden lg:block">
        <img
          src="https://readdy.ai/api/search-image?query=professional%20tools%20resources%20calculator%20documents%20checklist%20desk%20organized%20workspace%20warm%20light%20minimal%20clean%20modern%20office%20planning%20analysis&width=900&height=700&seq=toolhero001&orientation=squarish"
          alt="工具資源 保險建築師"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#F8F5F0] via-[#F8F5F0]/55 to-transparent"></div>
      </div>

      <div
        className="absolute inset-0 opacity-[0.04]"
        style={{ backgroundImage: 'radial-gradient(#5C5470 1px, transparent 1px)', backgroundSize: '24px 24px' }}
      ></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-10 pt-28 pb-20">
        <div className="max-w-[580px]">
          <div className="inline-flex items-center gap-2 bg-[#5C5470]/10 border border-[#5C5470]/20 rounded-full px-4 py-2 mb-8">
            <span className="w-2 h-2 rounded-full bg-[#D4A373]"></span>
            <span className="text-[#5C5470] font-medium" style={{ fontSize: '1rem' }}>保障分析工具中心</span>
          </div>

          <h1
            className="font-serif font-bold text-[#5C5470] mb-6"
            style={{ fontSize: 'clamp(2rem, 4vw, 2.75rem)', lineHeight: '1.3' }}
          >
            工具資源
            <br />
            <span className="text-[#D4A373]">先看懂現況，</span>
            <br />
            再規劃保障
          </h1>

          <p
            className="text-[#5C5470]/75 mb-10"
            style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}
          >
            提供保單健檢表、資產配置檢核表、醫療費用與長期照護試算工具，
            協助您更清楚掌握自己的保障結構。
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="#download-section"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('download-section')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center justify-center gap-2 bg-[#D4A373] text-white px-8 py-4 rounded-full font-semibold whitespace-nowrap hover:bg-[#c4935f] transition-all duration-200 hover:scale-105 cursor-pointer"
              style={{ fontSize: '1.1875rem' }}
            >
              <i className="ri-download-line"></i>
              下載保單健檢表
            </a>
            <a
              href="#calc-section"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('calc-section')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center justify-center gap-2 border-2 border-[#5C5470] text-[#5C5470] px-8 py-4 rounded-full font-semibold whitespace-nowrap hover:bg-[#5C5470] hover:text-white transition-all duration-200 cursor-pointer"
              style={{ fontSize: '1.1875rem' }}
            >
              <i className="ri-calculator-line"></i>
              開始保障分析
            </a>
          </div>

          <div className="mt-12 lg:hidden rounded-2xl overflow-hidden aspect-[16/9]">
            <img
              src="https://readdy.ai/api/search-image?query=professional%20tools%20resources%20calculator%20documents%20checklist%20desk%20organized%20workspace%20warm%20light%20minimal%20clean%20modern%20office%20planning%20analysis&width=800&height=450&seq=toolhero002&orientation=landscape"
              alt="工具資源"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
